/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
import Vue from 'vue'
let newUserInfoApiUrl = root.acOrgUserUrl.link;
let userListOfTeamHeadApiUrl = root.userListOfTeamHeadApiUrl.link;
let userRemoveFromTeamApiUrl = root.userRemoveFromTeamApiUrl.link;
let userAlgoInfoToTeamHeadApiUrl = root.userAlgoInfoToTeamHeadApiUrl.link;
let userAIModelInfoToTeamHeadApiUrl = root.userAIModelInfoToTeamHeadApiUrl.link;
let userAIRecentModelInfoToTeamHeadApiUrl = root.userAIRecentModelInfoToTeamHeadApiUrl.link;
let userAISharedModelInfoToTeamHeadApiUrl = root.userAISharedModelInfoToTeamHeadApiUrl.link;
let userHistoryModelsInfoToTeamHeadApiUrl = root.userHistoryModelsInfoToTeamHeadApiUrl.link;
let userModelCountToTeamHeadApiUrl = root.userModelCountToTeamHeadApiUrl.link;
let modelSearchToTeamHeadApiUrl = root.modelSearchToTeamHeadApiUrl.link;
let userSearchToTeamHeadApiUrl = root.userSearchToTeamHeadApiUrl.link;
export default {
  state: {
    getUserListOfTeamHeadState:{},
    getUserActivityByIDOfTeamHeadState:{},
    getUserInfoByIdForTeamHeadState:{},
    getModelsListForTeamHeadState:{},
    getMostUsedTrainModelForTeamHeadState:{},
    getSharedModelForTeamHeadState:{},
    getHistoryModelForTeamHeadState:{},
    getModelCountForTeamHeadState:{}
  },
  mutations: {
    getUserListOfTeamHeadMut(state, value){
      Vue.set(state,'getUserListOfTeamHeadState', value)
    },
    getUserActivityByIDOfTeamHeadMut(state,value){
      Vue.set(state,'getUserActivityByIDOfTeamHeadState', value)
    },
    getUserInfoByIdForTeamHeadMut(state,value){
      Vue.set(state,'getUserInfoByIdForTeamHeadState', value)
    },
    getModelsListForTeamHeadMutation(state,value){
      Vue.set(state,'getModelsListForTeamHeadState', value)
    },
    getMostUsedTrainModelForTeamHeadMutation(state,value){
      Vue.set(state,'getMostUsedTrainModelForTeamHeadState', value)
    },
    getSharedModelForTeamHeadMutation(state,value){
      Vue.set(state,'getSharedModelForTeamHeadState', value)
    },
    getHistoryModelForTeamHeadMutation(state,value){
      Vue.set(state,'getHistoryModelForTeamHeadState', value)
    },
    getModelCountForTeamHeadMutation(state,value){
      Vue.set(state,'getModelCountForTeamHeadState', value)
    }
  },
  actions: {
    // Algo Model Of User Info For Team
    getAlgoModelInfoOfTeamMemberFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(userAlgoInfoToTeamHeadApiUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create New User Info For Team
    createNewUserInfoForTeamFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(newUserInfoApiUrl,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update User Info For Team
    updateUserInfoForTeamFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(newUserInfoApiUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get User Info For Team
    getUserInfoByIdForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(newUserInfoApiUrl + payload.id + '/').then(res => {
              context.commit('getUserInfoByIdForTeamHeadMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    postUserListOfTeamHeadFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(userListOfTeamHeadApiUrl, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    getMyCoreTeamFiltersFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(userListOfTeamHeadApiUrl + '?members=' + payload.filter_key).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    getUserListOfTeamHeadFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(userListOfTeamHeadApiUrl, payload).then(res => {
            context.commit('getUserListOfTeamHeadMut', res.data);
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    getUserActivityByIDOfTeamHeadFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(userListOfTeamHeadApiUrl + payload.id + '/', payload).then(res => {
            context.commit('getUserActivityByIDOfTeamHeadMut', res.data);
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    removeUserForTeamToTeamHeadFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.delete(userRemoveFromTeamApiUrl + '?user_id=' +  payload.id).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get Models List For AI Task Function
    getModelListForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(userAIModelInfoToTeamHeadApiUrl + payload.id + '/').then(res => {
                context.commit('getModelsListForTeamHeadMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Most Used Trained Models For AI Task Function
    getMostUsedTrainModelForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(userAIRecentModelInfoToTeamHeadApiUrl + payload.id + '/' +  '?page_size=5').then(res => {
                context.commit('getMostUsedTrainModelForTeamHeadMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Shared Models For AI Task Function
    getSharedModelForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(userAISharedModelInfoToTeamHeadApiUrl + payload.id + '/').then(res => {
                context.commit('getSharedModelForTeamHeadMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get History Models For AI Task Function
    getHistoryModelForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(userHistoryModelsInfoToTeamHeadApiUrl + payload.id + '/').then(res => {
                context.commit('getHistoryModelForTeamHeadMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Model Count For AI Task Function
    getModelCountForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(userModelCountToTeamHeadApiUrl + payload.id + '/').then(res => {
                context.commit('getModelCountForTeamHeadMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Search Models For Team Head Function
    searchModelsForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(modelSearchToTeamHeadApiUrl + payload.data.id + '/' + '?search_term=' + payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Search User For Team Head Function
    searchUserForTeamHeadFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(userSearchToTeamHeadApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
    getUserListOfTeamHeadGetters: state => state.getUserListOfTeamHeadState,
    getUserActivityByIDOfTeamHeadGetters: state => state.getUserActivityByIDOfTeamHeadState,
    getUserInfoByIdForTeamHeadGetters: state => state.getUserInfoByIdForTeamHeadState,
    getModelsListForTeamHeadGetters: state => state.getModelsListForTeamHeadState,
    getMostUsedTrainModelForTeamHeadGetters: state => state.getMostUsedTrainModelForTeamHeadState,
    getSharedModelForTeamHeadGetters: state => state.getSharedModelForTeamHeadState,
    getHistoryModelForTeamHeadGetters: state => state.getHistoryModelForTeamHeadState,
    getModelCountForTeamHeadGetters: state => state.getModelCountForTeamHeadState
  }
}